import { render, staticRenderFns } from "./SignUpThanksPage.vue?vue&type=template&id=3b2a2172&scoped=true"
import script from "./SignUpThanksPage.vue?vue&type=script&lang=js"
export * from "./SignUpThanksPage.vue?vue&type=script&lang=js"
import style0 from "./SignUpThanksPage.vue?vue&type=style&index=0&id=3b2a2172&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a2172",
  null
  
)

export default component.exports